import React, { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { getRemotedbUrl, i18nIntl } from '../../lib/ep.js';

import SaveFeedback from '../builder/SaveFeedback.js';
import ButtonCollection from '../builder/ButtonCollection.js';
import { SecondaryButton } from '../builder/ActionButton.js';

const BuilderHeaderSimple = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const obj = props?.obj ?? {};

	useEffect(() => {
		setTimeout(() => {
			window.builder_loaded = true;
		}, 100);
	}, []);

	const strip = (html) => {
		var doc = new DOMParser().parseFromString(html, 'text/html');
		return doc.body.textContent || "";
	};

	const open_url = props?.open_url ?? false;
	const history_back = props?.history_back ?? false;
	const back_url = (!history_back) ? (props?.back_url ?? (props?.type ?? false)) : false;

	const historyBack = () => {
		window.history.back(-1);
	};

	const promo_type_icon = props?.icon ?? false;

	return (
		<header class="builder_header">
			<div style={{flexGrow:'1'}}>
				<div class={`promo_title${(promo_type_icon !== false) ? ` with_icon` : ''}`} style={(promo_type_icon !== false) ? { paddingInlineStart:'1.5em' } : null}>
					{(promo_type_icon !== false) && (
						<span class={`icon ${promo_type_icon}`} />
					)}

					<div class="title">
						<h1 class="whiteColor gui_cutTextOnOverflow" dangerouslySetInnerHTML={{ __html:strip(obj?.title ?? i18n("No title"))}} />
					</div>
				</div>
			</div>

			<div class="sided_ctas">
				<ButtonCollection _class={{other:'gui_only_wide_screen'}}>
					{(open_url !== false) && (
						<SecondaryButton
							_href={getRemotedbUrl(`${open_url}`)}
							_target='_blank'
							icon='knk-visible'
						>{obj?.open_link_title ?? "View page"}</SecondaryButton>
					)}

					<SecondaryButton
						_href={(back_url !== false) ? `${window.panel_url}${back_url}` : null}
						onClick={(back_url === false) ? () => historyBack() : null}
						icon='knk-logout'
						_class={{ other:'exit_builder_button' }}
					>Exit editor</SecondaryButton>
				</ButtonCollection>

				<ButtonCollection _class={{other:'gui_only_thin_screen'}}>
					{(open_url !== false) && (
						<SecondaryButton
							squared={true}
							_href={getRemotedbUrl(`${open_url}`)}
							_target='_blank'
							icon='knk-visible blueButton'
							color={false}
						/>
					)}

					<SecondaryButton
						squared={true}
						_href={(back_url !== false) ? `${window.panel_url}${back_url}` : null}
						onClick={(back_url === false) ? () => historyBack() : null}
						icon='knk-logout blueButton'
						color={false}
						_class={{ other:'exit_builder_button' }}
					/>
				</ButtonCollection>
			</div>

			<SaveFeedback />
		</header>
	)
}

export default injectIntl(BuilderHeaderSimple);